<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col v-for="(item, indice) in listado" :key="indice" cols="12" md="6" lg="3" class="pa-0">
            <ListadoItem :nombreCampo="item.nombre" :valorCampo="item.valor" />
          </v-col>

          <v-col cols="12">
            <v-btn
              v-if="!permisosAcademicosSedeSoloLectura"
              class="mx-1"
              color="primary"
              title="Agregar Estudiantes"
              small
              :disabled="form.programaUniversidad?.estado === estadosProgramasUniversidades.INSCRITO"
              @click="handleAbrirModalFormularioInscripciones">
              <v-icon>mdi-plus</v-icon>

              Agregar Estudiantes
            </v-btn>

            <v-btn
              v-if="(permisosAcademicosSede || permisosAcademicosNacional) && !permisosAcademicosSedeSoloLectura"
              small
              class="mx-1"
              :disabled="item == null"
              title="Eliminar Inscripción a Programa Universidad"
              @click="confirmacionEliminacion(item)">
              <v-icon>mdi-close</v-icon>

              Eliminar Inscripción
            </v-btn>

            <v-btn class="mx-1" title="Recargar" small @click="listar">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="12" class="px-2">
            <ListadoInscripcionesProgramaUniversidad
              ref="listadoRef"
              :items="items"
              :cargando="cargando"
              @selectItem="selectItem" />
          </v-col>
        </v-row>

        <ConfirmacionAccion
          ref="confirmacionRef"
          :titulo="confirmacion.titulo"
          :mensaje="confirmacion.mensaje"
          :realizandoAccion="confirmacion.realizandoAccion"
          @aceptar="confirmacion.fnAceptar" />

        <ModalFormularioInscripciones
          ref="ModalFormularioInscripcionesRef"
          nombreRecurso="Inscripción"
          :programaUniversidadId="form.programaUniversidad?.id"
          :itemsYaSeleccionados="items"
          :programaId="form.id"
          :universidadId="form.programaUniversidad?.sedeUniversidad?.universidadId"
          @actualizarListado="listar" />
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ListadoInscripcionesProgramaUniversidad from './ListadoInscripcionesProgramaUniversidad.vue';
import { mapGetters } from 'vuex';
import programaUniversidadMixin from '../mixins/programa-universidad.mixin';
import ListadoItem from './ListadoItem.vue';
import { ESTADOS_PROGRAMAS_UNIVERSIDADES, ESTADOS_SOLICITUDES_INSCRIPCIONES } from '../utils/constantes';
import programaService from '../services/programa.service';
import { concatenar, formatearErrores, imprimirModulo, obtenerModuloMasAlto } from '../utils/funciones';
import inscripcionProgramaUniversidadService from '../services/inscripcion-programa-universidad.service';
import ModalFormularioInscripciones from './ModalFormularioInscripciones.vue';

export default {
  name: 'ModalVerInscripcionesProgramaUniversidad',
  mixins: [programaUniversidadMixin],
  components: {
    ListadoInscripcionesProgramaUniversidad,
    ListadoItem,
    ModalFormularioInscripciones,
  },
  created() {
    this.$store.dispatch('pago/setFiltrarPorSede', true);
  },
  data() {
    return {
      nombreItem: 'Inscripciones al Programa Universidad',
      detallesSolicitudesInscripciones: [],
      cargandoPdf: false,
      cargandoTodosPdf: false,
      estadosSolicitudesInscripciones: ESTADOS_SOLICITUDES_INSCRIPCIONES,
      estadosProgramasUniversidades: ESTADOS_PROGRAMAS_UNIVERSIDADES,
    };
  },
  computed: {
    ...mapGetters({
      permisosAcademicosSede: 'pago/permisosAcademicosSede',
      permisosAcademicosNacional: 'pago/permisosAcademicosNacional',
      permisosAcademicosSedeSoloLectura: 'pago/permisosAcademicosSedeSoloLectura',
    }),
    listado() {
      return [
        { nombre: 'Código', valor: this.form.codigo },
        { nombre: 'Sede', valor: this.form.sede?.nombre },
        {
          nombre: 'Gestión / Versión / Grupo',
          valor: `${this.form.gestion} / ${this.form.version} / ${this.form.grupo}`,
        },
        { nombre: 'Nombre Compuesto', valor: this.form.nombreCompuesto },
        {
          nombre: 'Módulo Actual',
          valor: this.programaModuloTexto,
        },
        { nombre: 'Código Programa Universidad', valor: this.form.programaUniversidad?.codigo || '-' },
        { nombre: 'Programa Universidad', valor: this.form.programaUniversidad?.programaNombre || '-' },
        { nombre: 'Universidad', valor: this.form.universidad?.nombre },
      ];
    },
    programaModuloMasAlto() {
      const programasModulos = this.form?.programasModulos;

      return obtenerModuloMasAlto(programasModulos);
    },
    programaModuloTexto() {
      return imprimirModulo(this.programaModuloMasAlto);
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        codigo: null,
        sedeId: null,
        sede: null,
        gestion: null,
        nombreCompuesto: null,
        postgradoId: null,
        postgrado: null,
        programaUniversidadId: null,
        programaUniversidad: null,
        nombreCorto: null,
        version: null,
        grupo: null,
        universidadId: null,
        universidad: null,
        programasModulos: [],
        programaReportado: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        codigo: data.codigo,
        sedeId: data.sedeId,
        sede: data.sede,
        gestion: data.gestion,
        nombreCompuesto: data.nombreCompuesto,
        postgradoId: data.postgradoId,
        postgrado: data.postgrado,
        programaUniversidadId: data.programaUniversidadId,
        programaUniversidad: data.programaUniversidad,
        nombreCorto: data.nombreCorto,
        version: data.version,
        grupo: data.grupo,
        universidadId: data.universidadId,
        universidad: data.universidad,
        programasModulos: data.programasModulos || [],
        programaReportado: data.programaReportado,
      };
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
      this.listar();
    },
    async listar() {
      const id = this.form.id;

      this.items = [];
      this.item = null;
      this.cargando = true;

      try {
        const response = await programaService.findAllInscripcionesProgramaUniversidad(id);
        const data = response.data;
        const datos = data?.datos || [];
        const mensaje = data?.mensaje || null;

        this.items = datos.sort(
          (a, b) =>
            a.inscripcion.estudiante?.primerApellido?.localeCompare(b.inscripcion.estudiante?.primerApellido) ||
            a.inscripcion.estudiante?.segundoApellido?.localeCompare(b.inscripcion.estudiante?.segundoApellido) ||
            a.inscripcion.estudiante?.nombres?.localeCompare(b.inscripcion.estudiante?.nombres),
        );

        this.$notify({
          group: 'notifications',
          title: `${this.nombreItem.toUpperCase()} - Listado`,
          text: mensaje || 'Listado exitoso',
          type: 'success',
        });
      } catch (error) {
        this.$notify({
          group: 'notifications',
          title: `${this.nombreItem.toUpperCase()} - Error`,
          text: error.message || 'Error al listar',
          type: 'error',
        });
      } finally {
        this.cargando = false;
      }

      this.item = null;
    },
    confirmacionEliminacion(item) {
      if (this.form.programaReportado) {
        this.$notify({
          group: 'notifications',
          title: `${this.nombreItem.toUpperCase()} - Error`,
          text: `No se puede eliminar la inscripción porque el programa ya ha sido reportado para su inscripción a la universidad.`,
          type: 'error',
        });

        return;
      }

      this.confirmacion.titulo = `Eliminar ${this.nombreItem}`;
      this.confirmacion.mensaje = /*html*/ `
      ¿Está seguro de eliminar la inscripción del programa universidad <strong>${
        this.form.programaUniversidad?.programaNombre
      }</strong> al estudiante <strong>${concatenar(
        item.inscripcion.estudiante.numeroDocumento,
        '-',
        item.inscripcion.estudiante.nombres,
        item.inscripcion.estudiante.primerApellido,
        item.inscripcion.estudiante.segundoApellido,
      )}</strong>? <br />
      Esta acción no se puede deshacer. <br />
      Al aceptar, usted (<strong>${concatenar(
        this.$store.state.DATA_USER.nombres,
        this.$store.state.DATA_USER.pri_apellido,
        this.$store.state.DATA_USER.seg_apellido,
      )}</strong>), queda registrado como responsable de esta acción.`;
      this.confirmacion.fnAceptar = this.eliminarInscripcionProgramaUniversidad;
      this.$refs.confirmacionRef.abrir();
    },
    async eliminarInscripcionProgramaUniversidad() {
      if (this.item?.detallesSolicitudesPagos?.length > 0) {
        this.$notify({
          group: 'notifications',
          title: `${this.nombreItem.toUpperCase()} - Error`,
          text: 'No se puede eliminar la inscripción porque tiene solicitudes de pago asociadas.',
          type: 'error',
        });
        return;
      }

      this.confirmacion.realizandoAccion = true;

      const datos = {
        realizadoPorId: this.$store.state.DATA_USER.id,
        realizadoPor: concatenar(
          this.$store.state.DATA_USER.nombres,
          this.$store.state.DATA_USER.pri_apellido,
          this.$store.state.DATA_USER.seg_apellido,
        ),
      };

      try {
        const response = await inscripcionProgramaUniversidadService.remove(this.item.id, datos);
        const data = response.data;
        const mensaje = data?.mensaje || 'Inscripción eliminada exitosamente';

        this.$notify({
          group: 'notifications',
          title: `${this.nombreItem.toUpperCase()} - Eliminación`,
          text: mensaje,
          type: 'success',
        });

        this.$refs.confirmacionRef.cerrar();
        this.listar();
      } catch (error) {
        const data = error?.response?.data;
        const estado = error?.response?.status;
        const mensaje = data?.mensaje;
        const errores = data?.errores;
        const erroresFormateados = formatearErrores(errores);

        this.$notify({
          group: 'notifications',
          title: `${this.nombreItem.toUpperCase()} - Error`,
          text: estado == 422 ? erroresFormateados : mensaje || 'Error al eliminar la inscripción',
          type: 'error',
        });
      } finally {
        this.confirmacion.realizandoAccion = false;
      }
    },
    handleAbrirModalFormularioInscripciones() {
      if (this.form.programaReportado) {
        this.$notify({
          group: 'notifications',
          title: `Inscripciones - Error`,
          text: `No se pueden agregar más inscripciones porque el programa ya ha sido reportado para su inscripción a la universidad.`,
          type: 'error',
        });

        return;
      }

      this.$refs.ModalFormularioInscripcionesRef.abrir(this.accionesCrud.REGISTRAR, []);
    },
  },
};
</script>